import { render, staticRenderFns } from "./ModalLemonGrass.vue?vue&type=template&id=487d8e4e"
import script from "./ModalLemonGrass.vue?vue&type=script&lang=js"
export * from "./ModalLemonGrass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports